import * as signalR from "@microsoft/signalr";
import GlobalConst from "../../constants/GlobalConst";

var maxRetryAttempts = 5;
var attempts = 0;

var connectionProxy = {
    onReconnected : null,
    handlers: [],
    connection: null,
    connect: function(){

        console.log("Connecting to TFHub")

            this.connection = new signalR.HubConnectionBuilder()
            .withUrl(GlobalConst.API.BASEURL+'tfHub', {
                transport : signalR.HttpTransportType.WebSockets,
                accessTokenFactory : ()=>{
                    this.access_token = localStorage.getItem("access_token");
                    return this.access_token;
                }
            })
            .withAutomaticReconnect()
            //.configureLogging(signalR.LogLevel.Debug)
            .build();
            this.handlers.map( h=>{
               this.connection.on(h.eventName, h.handler);
            });

            this.connection.onreconnected(()=>{
                console.log("Connection reestablished");
                                            if( this.onReconnected)
                                                this.onReconnected();
                                            });
        if(!this.connection){
            console.log('Connection is null');
            this.connection = {state:"Disconnected"};
            return;
        }

        this.connection
            .start()
            .then(()=>{
                console.log('Now connected, connection ID=' + this.connection.connectionId);
                this.deQueue();
            })
            .catch((err)=>{
                this.state = this.connection.state;
                console.log(err);
                //retry in 1 sec
                if(attempts++ < maxRetryAttempts)
                    setTimeout(()=>{
                        if(this.connection.state === signalR.HubConnectionState.Disconnected)
                            this.connect();
                    },1000);
            });
    },
    refresh: function(){
        console.log('refreshing connection ' + this.connection.state + " " + this.access_token + " " + localStorage.getItem("access_token"));

        if(this.access_token === localStorage.getItem("access_token")){
            console.log("access_token did not change, skipping refresh");
            return;
        }

        if (this.connection && this.connection.state === signalR.HubConnectionState.Connected) {
            try {
                this.connection.stop()
                    .then(() => {
                        console.log('Connection stopped successfully', this.connection.state);
                        setTimeout(()=>{
                            this.connect();
                        }, 0);

                    }).catch(err => {
                    console.error('Error while stopping the connection:', err);
                });
            }catch(err){
                console.error('Error while stopping the connection 2:', err);
            }
        } else {
            console.log("Connection is not in the Connected state. xxxx" , this.connection.state);
        }
    },
    on : function(eventName, handler){
        if(!this.handlers.some(x=>x.eventName==eventName && x.handler==handler))
            this.handlers.push({eventName, handler});
    },
    send: function(actionName, param, param2, param3){
        //console.log(actionName, param, param2, param3, this.connection.state, this.actionQueue.length);
        try{
            if(this.connection?.state === signalR.HubConnectionState.Connected)
                this.connection.invoke.apply(this.connection, Array.from(arguments))
                                      .catch(e => {
                                            console.warn('invoke catched',e);
                                      }); //we might need to add more params
            else
                this.pushToQueue(()=>{
                    this.send.apply(this, Array.from(arguments));
                })
        }catch(err){
            this.pushToQueue(()=>{
                this.send.apply(this, Array.from(arguments));
            })
        }
    },

    //Queued action
    actionQueue: [],
    pushToQueue: function(a){
        this.actionQueue.push(a);
    },
    deQueue: function(){
        this.actionQueue.forEach(a=>a());
        this.actionQueue = [];
    }
};

var _connectedAccountId = 0;
var _groupSubs = {};

function _reSubsToGroups(){
    if(_connectedAccountId > 0)
        connectionProxy.send("MapIds", _connectedAccountId);
    for(let resourceType in _groupSubs){
        _groupSubs[resourceType].forEach(id=>{
            connectionProxy.send("SubToGroup", resourceType, id.toString());
        });
    }
}

export function isWebSocketConnected(){
    return connectionProxy.connection && connectionProxy.connection.state == "Connected";
}
export function subToGroup(resourceType, id, ignoreIfAlreadySubscribed = false){

    if(!_groupSubs[resourceType])
        _groupSubs[resourceType] = [];
    if(!_groupSubs[resourceType].includes(id))
        _groupSubs[resourceType].push(id);
    else if(ignoreIfAlreadySubscribed)
        return;

    if(!connectionProxy.onReconnected)
        connectionProxy.onReconnected = ()=>_reSubsToGroups();

    connectionProxy.send("SubToGroup", resourceType, id.toString());
}
export function unSubToGroup(resourceType, id){

    if( _groupSubs[resourceType] && _groupSubs[resourceType].includes(id))
        _groupSubs[resourceType] = _groupSubs[resourceType].filter(x=>x!=id);

    connectionProxy.send("UnSubFromGroup",resourceType, id.toString());
}
export function mapAccountId(accountId){
    if(!accountId)
        return;
    _connectedAccountId = accountId;
    connectionProxy.send("MapIds", accountId);
    _reSubsToGroups();
}
export function mapWsEventsToActions(eventNamesMap){
    for(let eventName in eventNamesMap){
        connectionProxy.on(eventName, (payload)=>{
            connectionProxy.reduxDispatch({ type: "ws/"+eventName, payload })
        });
    }
}

export default connectionProxy;